function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallEndCalli = function SvgCallEndCalli(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M2.047 11.195c0-.02-.033-1.526 2.524-2.637C5.956 7.956 8.237 7.435 12 7.435s6.048.52 7.44 1.122c2.563 1.11 2.544 2.612 2.544 2.63l.001.03.001.024v3.015c0 1.297-.993 2.3-2.162 2.3H17.07c-1.17 0-2.16-1.013-2.16-2.3v-1a2.2 2.2 0 0 0-.471-.207c-.497-.145-1.25-.25-2.395-.25s-1.9.104-2.395.25a2.2 2.2 0 0 0-.471.207v1c0 1.295-.996 2.3-2.175 2.3H4.22c-1.178 0-2.174-1.015-2.174-2.3v-3.04l.001-.02zm18.338.12a2.37 2.37 0 0 0-.85-.907C18.43 9.7 16.252 9.035 12 9.035s-6.42.664-7.52 1.373c-.57.368-.8.826-.835.902v2.945c0 .373.235.7.574.7H7c.34 0 .575-.337.575-.7V12.97a.8.8 0 0 1 .046-.268c.06-.206.248-.576.87-.907.526-.28 1.547-.594 3.55-.594s3.025.314 3.55.594c.622.33.808.7.87.907a.8.8 0 0 1 .046.268v1.286c0 .37.227.7.56.7h2.754c.335 0 .562-.34.562-.7v-2.94z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallEndCalli);
export default ForwardRef;